module.exports = __webpack_public_path__ + "img/vitran.2c2bc615.jpg";